import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Messages.scss";
import Button from "./Button.mjs";
import { convertText, groupBy } from "../../libs/common.mjs";
import { IconPlay } from "../Icons/Icons.mjs";
import { sessionAPI } from "../../api/sessionAPI.mjs";

export default function Messages({}) {
  const dispatch = useDispatch();
  const messagesRef = useRef(null);
  const sessionStore = useSelector((state) => state.session);
  const [messages, setMessages] = useState([]);
  const [messagesGroup, setMessagesGroup] = useState({});

  useEffect(() => {
    setMessages([...sessionStore.messages]);
  }, [sessionStore.messages]);

  useEffect(() => {
    setMessagesGroup(
      groupBy(
        messages.map((x) => ({ ...x, date: new Date(x.datetime).toLocaleDateString() })),
        "date"
      )
    );
  }, [messages]);
  useEffect(() => {
    setTimeout(() => {
      messagesRef.current.scrollTo({
        top: 10000 * messages.length,
        behavior: "smooth",
      });
    }, 500);
  }, [messagesGroup]);
  return (
    <div className="messages" ref={messagesRef}>
      {messages.length > 0 &&
        Object.keys(messagesGroup).map((date, indexGroup) => (
          <div key={indexGroup} className="messages__group">
            <div className="messages__group__date">
              <h5>{date}</h5>
            </div>
            <div className="messages__group__list">
              {messagesGroup[date].map((x, index) => (
                <div key={index} className={`message message_${x.direction}`}>
                  <h2
                    className="message__text"
                    dangerouslySetInnerHTML={{ __html: convertText(x?.text) }}
                  ></h2>
                  {x.buttons?.length > 0 && (
                    <div className="message__buttons">
                      {x.buttons.map((button, ind) => (
                        <Button key={ind} text={button.text} />
                      ))}
                    </div>
                  )}
                  {x.file && <img src={x.file} />}
                  <div className="message__footer">
                    {x?.text ? (
                      <IconPlay
                        classSvg="cursor-pointer"
                        onClick={() => {
                          sessionAPI.synthesizeSpeech(new Date().toISOString(), x.text);
                        }}
                      />
                    ) : (
                      <div></div>
                    )}
                    <h5>{new Date(x.datetime).toLocaleTimeString()}</h5>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
}
